import { render } from "./ProductCarousel.vue?vue&type=template&id=18320b71&ts=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=ts"
export * from "./ProductCarousel.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__